import * as React from 'react'
import { List } from 'antd'

import { ClockCircleOutlined, GlobalOutlined } from '@ant-design/icons'

const ClientInformation = (props) => {
  const { client } = props

  return (
    <>
      {/* <div className="user-image m-b-20">
      <img />
      </div>
      */}
      <div className='personal-info'>
        <h2>{client.name}</h2>
        <h4 className='user-designation m-b-10'>{client.type}</h4>
        <h4 className='user-designation m-b-10'>
          <GlobalOutlined /> {client?.country?.name.toUpperCase()}
        </h4>
        <h4 className='user-designation m-b-10'>
          <ClockCircleOutlined /> {client?.timezone}
        </h4>
      </div>
      <div className='contact-info'>
        <h2 className='after-underline'>Contact Information</h2>
        <div className='m-t-15 m-b-20'>
          <List.Item style={{ padding: '0px 0px' }}>
            <List.Item.Meta title='Name' description={`${client.last_name}, ${client.first_name}`} />
          </List.Item>
          {client.email && (
            <List.Item style={{ padding: '0px 0px' }}>
              <List.Item.Meta title='E-Mail' description={client.email} />
            </List.Item>
          )}
          {client.skype && (
            <List.Item style={{ padding: '0px 0px' }}>
              <List.Item.Meta title='Skype' description={client.skype} />
            </List.Item>
          )}
          {client.phone && (
            <List.Item style={{ padding: '0px 0px' }}>
              <List.Item.Meta title='Phone' description={client.phone} />
            </List.Item>
          )}
          {client.website && (
            <List.Item style={{ padding: '0px 0px' }}>
              <List.Item.Meta title='Website' description={client.website} />
            </List.Item>
          )}
        </div>
      </div>
    </>
  )
}

export default ClientInformation
